export const locales = {
  en: {
    noLiveGames: "Match is yet to begin.",
    timelineDescription: "Live timeline will be displayed here.",
    checkBackLater: "Please check back again later.",
    stayTuned: "Stay tuned. Your timeline is coming soon.",
  },
  fr: {
    noLiveGames: "Le match n'a pas encore commencé",
    checkBackLater: "Veuillez revenir plus tard.",
    timelineDescription: "La chronologie en direct sera affichée ici.",
    stayTuned: "Restez à l'écoute. Votre chronologie arrive bientôt.",
  },
  // add more languages as needed
};

export type LocaleKeys = keyof (typeof locales)["en"];
